import React from 'react';

const LandingPage = () => {
  return (
    <div className='p-5 center-item'>
      <div>
        <ol start='1' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span> Termes et conditions généraux</span>
            </strong>
          </li>
        </ol>
        <ul className='decimal_type'>
          <li>
            En utilisant cette plateforme, vous confirmez que vous avez lu et
            compris ses termes et conditions,
          </li>
          <li>
            Les termes et conditions de la plateforme s’appliquent et
            contraignent l’utilisateur final.
          </li>
          <li>Ces termes et conditions peuvent changer.</li>
        </ul>
      </div>
      <div>
        <ol start='2' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>Confidentialité et sécurité</span>
            </strong>
          </li>
        </ol>
        <ul>
          <li>
            <p>
              En utilisant cette plateforme et son service, vous consentez sans
              équivoque et volontairement à ce que la Banque Rwandaise de
              Développement (BRD) collecte, traite (y compris le profilage),
              transfère et partage avec des tiers vos données personnelles
              n’importe quand dans le but de fournir, d’améliorer ou mettre à
              niveau le service ou la plateforme sur laquelle le service est
              hébergé. Vos données personnelles peuvent également être partagées
              dans le but d’analyser ou d’évaluer votre éligibilité au programme
              de logement abordable auprès de l’Office Rwandais pour la
              Promotion de l’Habitat (RHA). Les informations personnelles
              collectées ne seront pas conservées plus longtemps que nécessaire
              pour vous prester le service.
            </p>
          </li>
          <li>
            <p>
              Vos informations et données personnelles ne seront utilisées
              qu’aux fins et conformément au consentement que vous avez fourni.
            </p>
          </li>
          <li>
            <p>
              Fournir des informations inexactes ou fausses lors de
              l’utilisation de ce service entraînera l’inéligibilité au
              programme et/ou des sanctions pénales.
            </p>
          </li>
          <li>
            <p>
              Les cookies sont des éléments d’informations générés par un
              serveur web et stockés dans l’ordinateur de l’utilisateur,
              disponibles pour un accès futur. Les cookies utilisent des
              informations spécifiques à l’utilisateur transmises par le serveur
              web sur l’ordinateur de l’utilisateur afin que les informations
              puissent être disponibles pour un accès ultérieur par lui-même ou
              d’autres serveurs. Le portail n’installera pas de cookies
              d'authentification ou de cookies similaires sur un appareil
              d’utilisateur final qui pourraient identifier les détails
              financiers de l’utilisateur final sans l’autorisation écrite
              expresse de l’utilisateur final. En utilisant ce service, vous
              consentez par écrit à la BRD pour collecter et installer des
              cookies, si nécessaire.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <ol start='3' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>Droit de partager des informations personnelles</span>
            </strong>
          </li>
        </ol>
        <ul>
          <li>
            <p>
              BRD recevra, transférera et partagera vos informations
              personnelles avec des tiers, y compris, mais sans s’y limiter à
              RHA, l’agence chargé du logement dans le seul but de l'application
              du programme de logement abordable.
            </p>
          </li>
          <li>
            <p>
              Dans le cadre des services fournis par la plateforme Giriwawe, vos
              données personnelles peuvent également être partagées à
              l’étranger.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <ol start='4' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>Résiliation, suspension et limitation</span>
            </strong>
          </li>
        </ol>
        <ul className='decimal_type'>
          <li>
            <span>
              Nonobstant cet engagement, vous reconnaissez et acceptez que nous
              sommes en droit de modifier, suspendre ou interrompre le service à
              tout moment et que nous ne serons pas responsables d’un dommage ou
              perte que vous pourriez subir si nous optons d’agir ainsi. Nous
              pouvons également opter de restreindre l’accès à certaines ou à
              toutes les fonctionnalités ou services que nous offrons.
            </span>
          </li>
          <li>
            <span>
              Cette plateforme peut être résiliée, suspendue et limitée à la
              discrétion de BRD. La fonctionnalité ou le service offert peut
              être temporairement ou définitivement modifié. Un avis
              d’informations sera partagé sur la plateforme. BRD ne sera pas
              responsable de tout un dommage ou de toute perte survenus à vos
              données personnelles.
            </span>
          </li>
        </ul>
      </div>
      <div>
        <ol start='5' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>Aucune garantie ou représentation</span>
            </strong>
          </li>
        </ol>
        <ul className='decimal_type'>
          <p>
            Le service est presté « tel quel » et « tel que disponible ». BRD ne
            garantit ni ne déclare que le service sera sans erreurs, ou que le
            contenu fourni sur ou via le service est ou sera exact, approprié,
            complet ou adapté ou compatible avec un objectif particulier.
          </p>
        </ul>
      </div>
      <div>
        <ol start='6' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>
                Clause de non-responsabilité et limitation de responsabilité
              </span>
            </strong>
          </li>
        </ol>
        <ul className='decimal_type'>
          <li>
            <p>
              À l'exception de toute responsabilité légale que la BRD peut avoir
              envers vous, et qui ne peut être niée ni modifiée par un accord
              entre vous et la Banque, ni nous, ni nos sociétés affiliées,
              employés, dirigeants, fournisseurs ou agents ne seront
              responsables ou redevables de quelque manière que ce soit
              résultant du dommage ou de la perte de quelque nature que ce soit
              résultant du service, de votre utilisation ou de votre confiance
              dans le service, ou des informations fournies sur ou via le
              service. Vous reconnaissez et comprenez que l’utilisation de ce
              service est entièrement à vos propres risques.
            </p>
          </li>
          <li>
            <p>
              La BRD n’est pas responsable des retards résultant de
              l’utilisation de liens vers des systèmes dorsaux gérés par
              d’autres départements et agences du Gouvernement du Rwanda qui ne
              sont pas sous le contrôle de la BRD.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <ol start='7' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>Capacité à conclure des contrats</span>
            </strong>
          </li>
        </ol>
        <ul className='decimal_type'>
          <li>
            <p>
              En utilisant le Service, vous certifiez (promettez de manière à ce
              que vous puissiez être tenu légalement lié par cette promesse) que
              vous avez la capacité juridique de conclure et d'être lié par des
              conditions contractuelles.
            </p>
          </li>
          <li>
            <p>Vous devez avoir au moins 18 ans pour utiliser le service.</p>
          </li>
          <li>
            <p>
              Si vous ne savez pas si vous avez la capacité juridique de
              conclure les contrats, vous devez contacter la banque (par quel
              moyen), et la BRD pourra vous fournir ces informations avant que
              vous ne continuiez à utiliser le service.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <ol start='8' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>
                Violation/non-respect des présents termes et conditions
              </span>
            </strong>
          </li>
        </ol>
        <ol className='decimal_type'>
          <li>
            <p>
              Si vous ne respectez pas ces termes et conditions, ou si vous
              utilisez le Service de manière non autorisée ou interagissez avec
              le service de manière illégale ou non autorisée, la BRD sera en
              droit de résilier votre accès au service immédiatement sans
              préavis, et sans préjudice de tout autre droit que nous pourrions
              avoir en vertu des présents termes et conditions ou en vertu de la
              loi.
            </p>
          </li>
          <li>
            <p>
              Si votre accès au service est résilié comme décrit ci-dessus, vous
              reconnaissez expressément que toutes les obligations qui existent
              entre vous et la banque au moment de cette résiliation, telles
              qu’énoncées dans les présents termes et conditions d’utilisation,
              continueront à être valides jusqu’à ce que ces obligations en
              suspens soient remplies.
            </p>
          </li>
        </ol>
      </div>
      <div>
        <ol start='9' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>Lois applicables</span>
            </strong>
          </li>
        </ol>
        <ol className='decimal_type'>
          <li>
            <p>
              Ces termes et conditions sont régis et seront interprétés
              conformément aux lois de la République du Rwanda sans référence à
              toute disposition de conflit de lois. Toutes les interactions et
              transactions effectuées ou menées sur ce service seront soumises
              aux lois de la République du Rwanda.
            </p>
          </li>
          <li>
            <p>
              Tout différend relatif à ou découlant de ces termes et d’une
              obligation non contractuelle découlant de ou en relation avec
              ceux-ci sera soumis à la compétence exclusive des juridictions du
              Rwanda après défaillance à résoudre le différend à l’amiable par
              le biais d’un mécanisme de règlement des conflits, conformément au
              mécanisme de règlement des conflits de la BRD.
            </p>
          </li>
          <li>
            <p>
              Toute médiation tenue en ce qui concerne les présents termes et
              conditions généraux sera menée à huis clos où nous et vous serons
              tenus de traiter tous les détails du différend soumis à la
              médiation, la conduite de la procédure de médiation et le résultat
              de la médiation comme confidentiels.
            </p>
          </li>
        </ol>
      </div>
      <p>
        <br />
      </p>
    </div>
  );
};

export default LandingPage;
